const s = require("./contentPart.module.scss");

import { default as React, useState, useRef, useContext, useLayoutEffect, CSSProperties } from "react";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ContentPart = (props: any) => {

    const containerRef: any = useRef(null);
    useLayoutEffect(() => {
        //calculate optimal zoom:
        if (!props.isLoading && containerRef.current.offsetWidth > 0) {
            setZoom(Math.max(0.5, Math.min(containerRef.current.offsetWidth * zoom / containerRef.current.scrollWidth,
                containerRef.current.offsetHeight * zoom / containerRef.current.scrollHeight)));
        }
    }, [props.isLoading]);
    const [zoom, setZoom] = useState(1);
    const style: CSSProperties = { border: "1px solid gray", textAlign: "center", cursor: "pointer" };

    return <div ref={containerRef} className="xx" style={{ flex: "1", position: "relative", overflow: "auto" }} >
        <div className={"noSelect"} style={{ position: "fixed", top: "10px", right: "10px", zIndex: 5, display: "grid", gap: "3px", gridTemplateColumns: "1fr 1fr 1fr", width: "100px", height: "25px", }}>
            <a style={style} onClick={() => setZoom(Math.max(0.5, zoom - 0.1))}>-</a>
            <a style={style} onClick={() => setZoom(1)}>{Math.round(zoom * 10) / 10}</a>
            <a style={style} onClick={() => setZoom(Math.min(1.5, zoom + 0.1))}>+</a>
        </div>
        <div style={{ zoom: zoom }}>
            {props.isLoading && <div className={s.loading} ></div>}
            {!props.isLoading && props.error !== "" && <div className={s.error} ><FontAwesomeIcon icon={faExclamationTriangle} /> {props.error}</div>}
            {!props.isLoading && props.error === "" && !props.data && <div className={s.error} ><FontAwesomeIcon icon={faExclamationTriangle} /> {"Wrong data packet received"}</div>}
            {props.children && React.cloneElement(props.children, {})}
        </div>
    </div>;
};
export default ContentPart;